import { Card, Row, Col, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import React, { useEffect, useState } from "react";
import { Loader } from "../../../custom/components/Loader";
import {
  activateVessel,
  approveVesselAccess,
  deactivateVessel,
  rejectVesselAccess,
  reschedulePermitRequest,
  requestVesselDeletion,
  leaveVessel,
} from "../../../api/controller/MyVesselController";
import SweetAlert from "react-bootstrap-sweetalert";
import { useRecoilValue } from "recoil";
import { userState } from "../../../api/state/AuthState";
import { STORAGE_PUBLIC_BASE } from "../../../custom/helpers/storagePublicBase";
import { HARBOR_ACTIONS_TEMP_DISABLED } from "../../../config/harborUiFlags";

/** Prefer API display strings; otherwise format ISO / date values for permit rows. */
function permitDateLabel(display, raw) {
  if (display) return display;
  if (raw == null || raw === "") return "—";
  const t = Date.parse(raw);
  if (Number.isNaN(t)) return String(raw);
  return new Intl.DateTimeFormat(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(t));
}

const Vessel = ({
  goToMyVessels,
  setCurrentScreen,
  selectedVessel,
  goToApplyForPermit,
  goToRequestToDock,
  handleUpdateVessel,
  // setMyVessels
}) => {
  const [loading, setLoading] = useState();
  const [successDlg, setSuccessDlg] = useState(false);
  const [successDlgText, setSuccessDlgText] = useState("");
  const [errorDlg, setErrorDlg] = useState(false);
  const [errorDlgText, setErrorDlgText] = useState("");
  const [rescheduleModal, setRescheduleModal] = useState(false);
  const [removalModal, setRemovalModal] = useState(false);
  const [confirmLeave, setConfirmLeave] = useState(false);
  const [removalReason, setRemovalReason] = useState('');
  const [removalLoading, setRemovalLoading] = useState(false);
  const [reschedulePermit, setReschedulePermit] = useState(null);
  const [rescheduleDate, setRescheduleDate] = useState('');
  const [rescheduleLoading, setRescheduleLoading] = useState(false);
  const user = useRecoilValue(userState)
  const isOwner = selectedVessel?.owner_id === user?.id;

  useEffect(() => {
  }, [selectedVessel]);

  const isUpcoming = (permit) => {
    const eff = new Date(permit.effective_at ?? permit.permit_effective_at);
    const exp = new Date(permit.expires_at ?? permit.permit_expires_at);
    const now = new Date();
    const in24h = new Date(now.getTime() + 24 * 60 * 60 * 1000);
    return eff > in24h && exp > now;
  };

  const handleRequestRemoval = async () => {
    // Required: staff cannot decide on a removal without knowing why.
    if (!removalReason.trim()) return;
    setRemovalLoading(true);
    const res = await requestVesselDeletion({
      id: selectedVessel.id,
      Reason: removalReason.trim(),
    });
    setRemovalLoading(false);
    if (res && res.Status === 'success') {
      setRemovalModal(false);
      setRemovalReason('');
      setSuccessDlgText('Removal requested. We will review it shortly.');
      setSuccessDlg(true);
      window.location.reload();
    } else {
      setErrorDlgText(res?.Message || 'Could not request removal.');
      setErrorDlg(true);
    }
  };

  const handleReschedule = async () => {
    if (!reschedulePermit || !rescheduleDate) return;
    setRescheduleLoading(true);
    const res = await reschedulePermitRequest({
      PermitId: reschedulePermit.id,
      NewEffectiveDate: rescheduleDate,
    });
    setRescheduleLoading(false);
    if (res && res.Status === 'success') {
      setRescheduleModal(false);
      setReschedulePermit(null);
      setSuccessDlgText('Permit rescheduled successfully.');
      setSuccessDlg(true);
      window.location.reload();
    } else {
      setErrorDlgText(res?.Message || 'Reschedule failed.');
      setErrorDlg(true);
    }
  };

  const handleApproveRequest = async ({ userRequestId }) => {
    setLoading(true);
    const response = await approveVesselAccess({
      VesselUser: userRequestId,
    });
    if (response.Status === "error") {
      setErrorDlgText(response.Message);
      setErrorDlg(true);
    } else {
      setSuccessDlgText("User approved.");
      window.location.reload()
    }
    setLoading(false);
  };

  const handleRejectRequest = async ({ userRequestId }) => {
    setLoading(true);
    const response = await rejectVesselAccess({
      VesselUser: userRequestId,
    });
    if (response.Status === "error") {
      setErrorDlgText(response.Message);
      setErrorDlg(true);
    } else {
      setSuccessDlgText("User rejected.");
      setSuccessDlg(true);
    }
    setLoading(false);
  };

  // Giving up your own access, which the owner is told about. Distinct from
  // the owner removing somebody, below.
  const handleLeaveVessel = async () => {
    setLoading(true);
    const response = await leaveVessel({ Vessel: selectedVessel.id });
    if (response.Status === "error") {
      setErrorDlgText(response.Message);
      setErrorDlg(true);
    } else {
      setSuccessDlgText("You no longer have access to this vessel.");
      setSuccessDlg(true);
      window.location.reload();
    }
    setLoading(false);
  };

  const handleRemoveUser = async ({ userRequestId }) => {
    setLoading(true);
    const response = await rejectVesselAccess({
      VesselUser: userRequestId,
    });
    if (response.Status === "error") {
      setErrorDlgText(response.Message);
      setErrorDlg(true);
    } else {
      setSuccessDlgText("User removed.");
      setSuccessDlg(true);
    }
    setLoading(false);
  };

  const handleActivateVessel = async ({ vesselId }) => {
    setLoading(true);
    const response = await activateVessel({
      id: vesselId,
    });
    if (response.Status === "error") {
      setErrorDlgText(response.Message);
      setErrorDlg(true);
    } else {
      handleUpdateVessel({ vesselId: vesselId, tf: true });
      setSuccessDlgText("Vessel is now Active");
      setSuccessDlg(true);
    }
    setLoading(false);
  };

  const handleDeactivateVessel = async ({ vesselId }) => {
    setLoading(true);
    const response = await deactivateVessel({
      id: vesselId,
    });
    if (response.Status === "error") {
      setErrorDlgText(response.Message);
      setErrorDlg(true);
    } else {
      handleUpdateVessel({ vesselId: vesselId, tf: false });
      setSuccessDlgText("Vessel has been Deactivated");
      setSuccessDlg(true);
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <Loader loading={loading} transparent></Loader>
      <button
        className="btn btn-primary fs-6 py-1"
        onClick={() => selectedVessel?.owner_id === user.id ? goToMyVessels() : setCurrentScreen("initial")}
      >
        <span className="mdi mdi-chevron-left align-middle fs-3 me-2"></span>
        <span className="">Back</span>
      </button>
      <Card className="p-3 mt-4 mb-3">
        <Row>
          <Col className="col-8 col-sm-8 col-md-10 col-lg-10">
            <div className="text-left">
              <h1 className="">{selectedVessel?.name}</h1>
            </div>
          </Col>
        </Row>
        <Row>
          {selectedVessel?.vessel_image &&
            <Col className="col-8 col-sm-8 col-md-10 col-lg-12">
              <div className="my-4">
                <img className="img-fluid" alt="Vessel" src={STORAGE_PUBLIC_BASE + selectedVessel?.vessel_image} />
              </div>
            </Col>
          }
        </Row>
        <Row>
          <Col className="col-4 col-sm-4 col-md-2 col-lg-2">
            <div className="text-left">
              <span className="font-weight-semibold">Registration: </span>
              {selectedVessel?.registration_document && (
                <a 
                  href={STORAGE_PUBLIC_BASE + selectedVessel?.registration_document}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary"
                  style={{ cursor: 'pointer' }}
                >
                  (view)
                </a>
              )}
            </div>
          </Col>
          <Col className="col-8 col-sm-8 col-md-10 col-lg-10">
            <div className="text-left">
              <span className="">{selectedVessel?.registration_number}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="col-4 col-sm-4 col-md-2 col-lg-2">
            <div className="text-left">
              <span className="font-weight-semibold">Contact No:</span>
            </div>
          </Col>
          <Col className="col-8 col-sm-8 col-md-10 col-lg-10">
            <div className="text-left">
              <span className="">
                {selectedVessel?.representative_contact_number}
              </span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="col-4 col-sm-4 col-md-2 col-lg-2">
            <div className="text-left">
              <span className="font-weight-semibold">REF Code:</span>
            </div>
          </Col>
          <Col className="col-8 col-sm-8 col-md-10 col-lg-10">
            <div className="text-left">
              <span className="">{selectedVessel?.reference}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="col-4 col-sm-4 col-md-2 col-lg-2">
            <div className="text-left">
              <span className="font-weight-semibold">Status</span>
            </div>
          </Col>
          <Col className="col-8 col-sm-8 col-md-10 col-lg-10">
            <div className="text-left">
              <Badge
                className={`bg-${
                  selectedVessel?.status === "PENDING"
                    ? "warning"
                    : selectedVessel?.status === "REJECTED"
                    ? "danger"
                    : "success"
                }`}
              >
                <span className="px-2 fs-6">{selectedVessel?.status}</span>
              </Badge>
            </div>
          </Col>
        </Row>
        {selectedVessel?.status === "APPROVED" && selectedVessel?.owner_id === user?.id ? (
          <Row className="mt-3">
            <Col className="mb-0 col-md-4 col-lg-4 col-xl-3">
              <div className="text-left">
                {selectedVessel?.active ? (
                  <SimpleButton
                    color={"warning"}
                    icon={"mdi mdi-chevron-right"}
                    text={"Deactivate Vessel"}
                    clickFn={() =>
                      handleDeactivateVessel({ vesselId: selectedVessel?.id })
                    }
                  />
                ) : (
                  <SimpleButton
                    color={"success"}
                    icon={"mdi mdi-chevron-right"}
                    text={"Activate Vessel"}
                    clickFn={() =>
                      handleActivateVessel({ vesselId: selectedVessel.id })
                    }
                  />
                )}
              </div>
            </Col>
          </Row>
        ) : null}
      </Card>
      {selectedVessel.status === "APPROVED" &&
      selectedVessel.active === true ? (
        <Card className="p-3">
          <h4 className="font-weight-semibold ">Requests</h4>
          <Row>
            <Col className="col-md-4 col-lg-4 col-xl-3">
              <SimpleButton
                color={"primary"}
                icon={"mdi mdi-chevron-right"}
                text={"Request to Dock"}
                clickFn={goToRequestToDock}
                disabled={HARBOR_ACTIONS_TEMP_DISABLED}
              />
            </Col>
          </Row>
        </Card>
      ) : null}

      {selectedVessel.owner_id === user?.id ? (
        <Card className="p-3">
          <h4 className="font-weight-semibold ">Remove Vessel</h4>
          {selectedVessel.deletion_requested_at ? (
            <p className="text-muted mb-0">
              Removal has been requested and is awaiting review.
            </p>
          ) : (
            <>
              {selectedVessel.deletion_rejection_reason ? (
                <p className="text-danger">
                  A previous request was declined: {selectedVessel.deletion_rejection_reason}
                </p>
              ) : null}
              <Row>
                <Col className="col-md-4 col-lg-4 col-xl-3">
                  <SimpleButton
                    color={"danger"}
                    icon={"mdi mdi-trash-can"}
                    text={"Request Removal"}
                    clickFn={() => setRemovalModal(true)}
                  />
                </Col>
              </Row>
            </>
          )}
        </Card>
      ) : null}

      <Modal isOpen={removalModal} toggle={() => setRemovalModal(false)} centered>
        <ModalHeader toggle={() => setRemovalModal(false)}>Request Removal</ModalHeader>
        <ModalBody>
          <p>
            Your request will be reviewed before the removal of the vessel. Any
            Active Permit on the {selectedVessel.name} will end once the vessel
            has been removed.
          </p>
          <label className="form-label">
            Reason <span className="text-danger">*</span>
          </label>
          <input
            className="form-control"
            value={removalReason}
            onChange={(e) => setRemovalReason(e.target.value)}
            placeholder="e.g. vessel sold"
            maxLength={500}
            required
          />
          <small className="text-muted">Required. Tell us why this vessel should be removed.</small>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleRequestRemoval} disabled={removalLoading || !removalReason.trim()}>
            {removalLoading ? "Sending..." : "Request Removal"}
          </Button>
          <Button color="secondary" onClick={() => setRemovalModal(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={confirmLeave} toggle={() => setConfirmLeave(false)} centered>
        <ModalHeader toggle={() => setConfirmLeave(false)}>Remove My Access</ModalHeader>
        <ModalBody>
          You will no longer see {selectedVessel.name} or its permits, and the owner is told
          you have removed yourself. They can add you again later.
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={() => { setConfirmLeave(false); handleLeaveVessel(); }}>
            Remove My Access
          </Button>
          <Button color="secondary" onClick={() => setConfirmLeave(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>

      {selectedVessel.status === "APPROVED" && selectedVessel.active === true ? (
        <Card className="p-3">
          <h4 className="font-weight-semibold ">Permits</h4>
          {isOwner ? (
            <Row>
              <Col className="col-md-4 col-lg-4 col-xl-3">
                <SimpleButton
                  color={"primary"}
                  icon={"mdi mdi-chevron-right"}
                  text={"Apply for Permit"}
                  clickFn={goToApplyForPermit}
                  disabled={HARBOR_ACTIONS_TEMP_DISABLED}
                />
              </Col>
            </Row>
          ) : null}

          <br />
          <h6>Active Permits</h6>
          {selectedVessel.permits.length > 0 ? (
            selectedVessel.permits.map((item, key) => (
              <Row key={key} className="align-items-center mb-1">
                <Col className="col-md-8 col-lg-7 col-xl-6">
                  <SimpleCard
                    key={key}
                    item={item}
                    color={"success"}
                    // isCancel={false}
                  />
                </Col>
                {isOwner && isUpcoming(item) && (
                  <Col className="col-md-4 col-lg-3 col-xl-2 mt-2 mt-md-0">
                    <button
                      className="btn btn-outline-primary fs-6 w-100"
                      onClick={() => {
                        setReschedulePermit(item);
                        setRescheduleDate('');
                        setRescheduleModal(true);
                      }}
                      disabled={HARBOR_ACTIONS_TEMP_DISABLED}
                    >
                      <span className="mdi mdi-calendar-edit align-middle fs-5 me-1"></span>
                      Reschedule
                    </button>
                  </Col>
                )}
              </Row>
            ))
          ) : (
            <span>There are no active permits for this vessel.</span>
          )}
        </Card>
      ) : null}

      {selectedVessel.status === "APPROVED" ? (
        <Card className="p-3">
          <h4 className="font-weight-semibold">Other Users</h4>
          {selectedVessel.users.length > 0 ? (
            <div>
              {selectedVessel.users.filter((a) => a.approved === 0).length >
              0 ? (
                <h6>Requests to Add</h6>
              ) : null}
              {selectedVessel.users
                .filter((a) => a.approved === 0)
                .map((item, key) => (
                  <div key={key}>
                    <Row>
                      <Col className="col-md-6 col-lg-6 col-xl-6">
                        <Card
                          outline
                          color="light"
                          className="border-2 p-3 mb-3"
                        >
                          <Row>
                            <Col className="col-12 pb-2">
                              <Col>
                                <b>Username: </b>
                                {item.user?.name}
                              </Col>
                              <Col>
                                <b>Email: </b>
                                {item.user?.email}
                              </Col>
                            </Col>
                            <Col className="col-6">
                              <button
                                className="btn btn-danger fs-6 w-100"
                                onClick={() =>
                                  handleRejectRequest({
                                    userRequestId: item.id,
                                  })
                                }
                              >
                                <span className="me-2">Reject</span>
                                <span className="mdi mdi-close align-middle fs-4 "></span>
                              </button>
                            </Col>
                            <Col className="col-6">
                              <button
                                className="btn btn-success fs-6 w-100"
                                onClick={() =>
                                  handleApproveRequest({
                                    userRequestId: item.id,
                                  })
                                }
                              >
                                <span className="me-2">Approve</span>
                                <span className="mdi mdi-check align-middle fs-4"></span>
                              </button>
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                ))}
              {selectedVessel.users.filter((a) => a.approved === 1).length >
              0 ? (
                <h6>Current Users</h6>
              ) : null}

              {selectedVessel.users
                .filter((a) => a.approved === 1)
                .map((item, key) => (
                  <div>
                    <Row>
                      <Col className="col-md-6 col-lg-6 col-xl-6">
                        <Card
                          outline
                          color="light"
                          className="border-2 p-3 mb-3"
                        >
                          <Row>
                            <Col className="col-12 pb-2">
                              <Col>
                                <b>Username: </b>
                                {item.user?.name}
                              </Col>
                              <Col>
                                <b>Email: </b>
                                {item.user?.email}
                              </Col>
                            </Col>
                            {isOwner && item.user?.id !== selectedVessel.owner_id ? (
                              <Col className="col-12">
                                <button
                                  className="btn btn-danger fs-5 w-100"
                                  onClick={() =>
                                    handleRemoveUser({
                                      userRequestId: item.id,
                                    })
                                  }
                                >
                                  <span className="me-2">Remove User</span>
                                  <span className="mdi mdi-close align-middle fs-4 "></span>
                                </button>
                              </Col>
                            ) : null}
                            {!isOwner && item.user?.id === user?.id ? (
                              <Col className="col-12">
                                <button
                                  className="btn btn-outline-danger fs-5 w-100"
                                  onClick={() => setConfirmLeave(true)}
                                >
                                  <span className="me-2">Remove My Access</span>
                                  <span className="mdi mdi-exit-to-app align-middle fs-4 "></span>
                                </button>
                              </Col>
                            ) : null}
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                ))}

              {/* {selectedVessel.users.map((item, key) => {
                if (item.approved === 0) {
                  return (
                    <div key={key}>
                      <h6>Requests to Add</h6>
                      <Row>
                        <Col className="col-md-6 col-lg-6 col-xl-6">
                          <Card
                            outline
                            color="light"
                            className="border-2 p-3 mb-3"
                          >
                            <Row>
                              <Col className="col-12 pb-2">
                                <Col>
                                  <b>Username: </b>
                                  {item.user.name}
                                </Col>
                                <Col>
                                  <b>Email: </b>
                                  {item.user.email}
                                </Col>
                              </Col>
                              <Col className="col-6">
                                <button
                                  className="btn btn-danger fs-6 w-100"
                                  onClick={() =>
                                    handleRejectRequest({
                                      userRequestId: item.id,
                                    })
                                  }
                                >
                                  <span className="me-2">Reject</span>
                                  <span className="mdi mdi-close align-middle fs-4 "></span>
                                </button>
                              </Col>
                              <Col className="col-6">
                                <button
                                  className="btn btn-success fs-6 w-100"
                                  onClick={() =>
                                    handleApproveRequest({
                                      userRequestId: item.id,
                                    })
                                  }
                                >
                                  <span className="me-2">Approve</span>
                                  <span className="mdi mdi-check align-middle fs-4"></span>
                                </button>
                              </Col>
                            </Row>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  );
                } else {
                  return (
                    <div key={key}>
                      <h6>Current Users</h6>
                      <Row>
                        <Col className="col-md-6 col-lg-6 col-xl-6">
                          <Card
                            outline
                            color="light"
                            className="border-2 p-3 mb-3"
                          >
                            <Row>
                              <Col className="col-12 pb-2">
                                <Col>
                                  <b>Username: </b>
                                  {item.user.name}
                                </Col>
                                <Col>
                                  <b>Email: </b>
                                  {item.user.email}
                                </Col>
                              </Col>
                              {item.user.id ===
                              selectedVessel.owner_id ? null : (
                                <Col className="col-12">
                                  <button
                                    className="btn btn-warning fs-5 w-100"
                                    onClick={() =>
                                      handleRemoveUser({
                                        userRequestId: item.id,
                                      })
                                    }
                                  >
                                    <span className="me-2">Remove User</span>
                                    <span className="mdi mdi-close align-middle fs-4 "></span>
                                  </button>
                                </Col>
                              )}
                            </Row>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  );
                }
              })} */}
            </div>
          ) : (
            <span>~ There are no other users ~</span>
          )}
        </Card>
      ) : null}

      {successDlg ? (
        <SweetAlert
          success
          title={"Success!"}
          confirmBtnText={"Close"}
          onConfirm={() => {
            setSuccessDlg(false);
          }}
        >
          <span>{successDlgText}</span>
        </SweetAlert>
      ) : null}
      {errorDlg ? (
        <SweetAlert
          error
          title={"Error!"}
          confirmBtnText={"Close"}
          onConfirm={() => {
            setErrorDlg(false);
          }}
        >
          {errorDlgText}
        </SweetAlert>
      ) : null}

      <Modal isOpen={rescheduleModal} toggle={() => setRescheduleModal(false)}>
        <ModalHeader toggle={() => setRescheduleModal(false)}>Reschedule Permit</ModalHeader>
        <ModalBody>
          <p className="text-muted mb-3">
            Choose a new start date and time. Must be at least 24 hours from now.
          </p>
          <input
            type="datetime-local"
            className="form-control"
            value={rescheduleDate}
            min={(() => {
              const d = new Date();
              d.setDate(d.getDate() + 1);
              return d.toISOString().slice(0, 16);
            })()}
            onChange={e => setRescheduleDate(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleReschedule} disabled={rescheduleLoading || !rescheduleDate}>
            {rescheduleLoading ? 'Saving...' : 'Confirm'}
          </Button>
          <Button color="secondary" onClick={() => setRescheduleModal(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};
export default Vessel;

const SimpleCard = ({ item, color, isCancel }) => {
  return (
    <Card
      outline
      color={color}
      className="p-3 border-2 mb-2"
      style={{ cursor: "pointer" }}
    >
      <Row>
        <Col
          className="col-4 align-middle"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <span className=" font-weight-semibold fs-6">From</span>
        </Col>
        <Col
          className="col-4 align-middle"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <span className=" font-weight-semibold fs-6">To</span>
        </Col>
        <Col
          className="col-4 align-middle"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <span className=" font-weight-semibold fs-6">Duration</span>
        </Col>
      </Row>
      <Row>
        <Col
          className="col-4 align-middle"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <span className="  fs-6">
            {permitDateLabel(
              item.permit_effective_display,
              item.effective_at ?? item.effective_date
            )}
          </span>
        </Col>
        <Col
          className="col-4 align-middle"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <span className="  fs-6">
            {permitDateLabel(
              item.permit_expiry_display,
              item.expires_at ?? item.expiry_date
            )}
          </span>
        </Col>
        <Col
          className="col-4 align-middle"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <span className=" fs-6">{item.permit_type.name}</span>
        </Col>
      </Row>
      {isCancel && isCancel === true ? (
        <Row>
          <Col>
            <button
              className="btn btn-warning fs-5 mt-2 w-100"
              // onClick={() => goToMyVessels()}
            >
              <span className="mdi mdi-cancel align-middle fs-3 me-2"></span>
              <span className="">Cancel</span>
            </button>
          </Col>
        </Row>
      ) : null}
    </Card>
  );
};

const SimpleButton = ({ color, icon, text, clickFn, disabled }) => {
  const onActivate = () => {
    if (disabled) return;
    clickFn();
  };
  return (
    <div
      onClick={onActivate}
      title={
        disabled ? "This action is temporarily unavailable" : undefined
      }
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.55 : 1,
      }}
    >
      <Card
        className={`px-3 py-2 mb-1 bg-${disabled ? "secondary" : color} text-white`}
        style={{ marginBottom: 0 }}
      >
        <Row>
          <Col
            className="col-10 align-middle"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <span className=" fs-6">{text}</span>
          </Col>
          <Col
            className="col-2 align-middle"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <span
                className={`${icon} align-middle text-white`}
                style={{ fontSize: "20px" }}
              />
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  );
};
